module.exports = __webpack_public_path__ + "static/media/roulette_neo.relax.0e9501cb.jpeg";